var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$detect == 'mobile')?_c('profileM'):_c('profileW')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }